import { createApp } from 'vue'
import App from './App.vue'
import { router } from "./router";
import pinia from "./store";
import ElementPlus from 'element-plus'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import vue3SeamlessScroll from "vue3-seamless-scroll";
import 'element-plus/theme-chalk/index.css'
import "animate.css"

createApp(App).use(ElementPlus).use(VueAnimateOnScroll).use(vue3SeamlessScroll).use(router).use(pinia).mount('#app')
